module.exports = __webpack_public_path__ + "img/arrow-for-select.59c32765.svg";